"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentListModal = exports.omegaBreakDownIntroducedVersion = exports.DocVersionEnum = void 0;
exports.getDocumentVersionByDate = getDocumentVersionByDate;
exports.getDocumentVersionNumberOnly = getDocumentVersionNumberOnly;
exports.getDocumentBrand = getDocumentBrand;
exports.getLatestDocumentVersion = getLatestDocumentVersion;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var commonFunctions_1 = require("../../../commonFunctions");
var uuid_1 = require("uuid");
var rxjs_1 = require("rxjs");
var DocProductEnum;
(function (DocProductEnum) {
    DocProductEnum["ANNUAL_CAR"] = "Annual_Car";
    DocProductEnum["CAR"] = "Car";
    DocProductEnum["RENTERS"] = "Renters";
})(DocProductEnum || (DocProductEnum = {}));
var DocTypeEnum;
(function (DocTypeEnum) {
    DocTypeEnum["BDI"] = "BDI";
    DocTypeEnum["DOI"] = "DOI";
    DocTypeEnum["IPID"] = "IPID";
    DocTypeEnum["IPID_ALLIANZ_ESSENTIALS"] = "IPID_ALLIANZ_ESSENTIALS";
    DocTypeEnum["IPID_ALLIANZ_SILVER"] = "IPID_ALLIANZ_SILVER";
    DocTypeEnum["IPID_BRITANNIA_ESSENTIALS"] = "IPID_BRITANNIA_ESSENTIALS";
    DocTypeEnum["IPID_BRITANNIA"] = "IPID_BRITANNIA";
    DocTypeEnum["IPID_BRITANNIA_PREMIER"] = "IPID_BRITANNIA_PREMIER";
    DocTypeEnum["MLE"] = "MLE";
})(DocTypeEnum || (DocTypeEnum = {}));
var DocVersionEnum;
(function (DocVersionEnum) {
    DocVersionEnum["V1"] = "v1";
    DocVersionEnum["V2"] = "v2";
    DocVersionEnum["V3"] = "v3";
    DocVersionEnum["V4"] = "v4";
    DocVersionEnum["V5"] = "v5";
    DocVersionEnum["V6"] = "v6";
    DocVersionEnum["V7"] = "v7";
    DocVersionEnum["V8"] = "v8";
    DocVersionEnum["V9"] = "v9";
    DocVersionEnum["V10"] = "v10";
    DocVersionEnum["V11"] = "v11";
})(DocVersionEnum || (exports.DocVersionEnum = DocVersionEnum = {}));
var documentsV10EffectiveDate = (_a = process.env.REACT_APP_DOCUMENTS_V10_EFFECTIVE_DATE) !== null && _a !== void 0 ? _a : "2026-03-12";
var PRIVACY_NOTICE_URL = services_1.resourcesHelper.PRIVACY_NOTICE_URL, LEGAL_NOTICE_URL = services_1.resourcesHelper.LEGAL_NOTICE_URL;
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// To add new documents:
//      1. You need to add them to frontend/falcon-styles/public/resources/*under the appropriate brand and version*
//      2. Add the start date of the new documents to the map below.
// Keep in mind the document path pattern: {brand}{product}/{version}/{brand}{product}{document type}{version}
var AnnualCarVersionDate = [
    { docVersion: DocVersionEnum.V11, versionDate: new Date("2026-03-19") },
    { docVersion: DocVersionEnum.V10, versionDate: new Date(documentsV10EffectiveDate) },
    { docVersion: DocVersionEnum.V9, versionDate: new Date("2025-11-13") },
    { docVersion: DocVersionEnum.V8, versionDate: new Date("2025-05-22") },
    { docVersion: DocVersionEnum.V7, versionDate: new Date("2025-01-16") },
    { docVersion: DocVersionEnum.V6, versionDate: new Date("2024-07-11") },
    { docVersion: DocVersionEnum.V5, versionDate: new Date("2024-05-16") },
    { docVersion: DocVersionEnum.V4, versionDate: new Date("2023-08-24") },
    { docVersion: DocVersionEnum.V3, versionDate: new Date("2022-08-05") },
    { docVersion: DocVersionEnum.V2, versionDate: new Date("2021-11-30") },
];
var BritanniaCarVersionDate = [
    { docVersion: DocVersionEnum.V1, versionDate: new Date("2026-02-18") }
];
var DocNameMap = [
    { docType: DocTypeEnum.BDI, docFullName: "".concat(services_1.resourcesHelper.THEME, " Annual Breakdown Document of Insurance") },
    { docType: DocTypeEnum.DOI, docFullName: services_1.resourcesHelper.THEME === "Britannia" ? "Britannia Car Insurance Policy Booklet" : "".concat(services_1.resourcesHelper.THEME, " Car Document of Insurance (DOI)") },
    { docType: DocTypeEnum.IPID, docFullName: "".concat(services_1.resourcesHelper.THEME, " Insurance Product Information Document (IPID)") },
    { docType: DocTypeEnum.IPID_BRITANNIA_PREMIER, docFullName: "".concat(services_1.resourcesHelper.THEME, " Insurance Product Information Document (IPID)") },
    {
        docType: DocTypeEnum.IPID_ALLIANZ_ESSENTIALS,
        docFullName: "".concat(services_1.resourcesHelper.THEME, " ").concat(services_1.resourcesHelper.TIER_1, " Insurance Product Information Document (IPID)")
    },
    {
        docType: DocTypeEnum.IPID_BRITANNIA_ESSENTIALS,
        docFullName: "".concat(services_1.resourcesHelper.THEME, " ").concat(services_1.resourcesHelper.TIER_1, " Insurance Product Information Document (IPID)")
    },
    {
        docType: DocTypeEnum.IPID_ALLIANZ_SILVER,
        docFullName: "".concat(services_1.resourcesHelper.THEME, " ").concat(services_1.resourcesHelper.TIER_2, " Insurance Product Information Document (IPID)")
    },
    {
        docType: DocTypeEnum.IPID_BRITANNIA,
        docFullName: "".concat(services_1.resourcesHelper.THEME, " ").concat(services_1.resourcesHelper.TIER_2, " Insurance Product Information Document (IPID)")
    },
    { docType: DocTypeEnum.MLE, docFullName: "".concat(services_1.resourcesHelper.THEME, " Motor Legal Expenses (MLE)") }
];
var DocNameMapOnline = [
    { docType: DocTypeEnum.BDI, docFullName: "".concat(services_1.resourcesHelper.PRODUCT, " Car Insurance Breakdown Document of Insurance") },
    { docType: DocTypeEnum.DOI, docFullName: services_1.resourcesHelper.THEME === "Britannia" ? "Britannia Car Insurance Policy Booklet" : "".concat(services_1.resourcesHelper.PRODUCT, " Car Insurance Document of Insurance") },
    { docType: DocTypeEnum.IPID, docFullName: "".concat(services_1.resourcesHelper.PRODUCT_TIER_3, " Car Insurance Product Information Document") },
    { docType: DocTypeEnum.IPID_BRITANNIA_PREMIER, docFullName: "".concat(services_1.resourcesHelper.PRODUCT_TIER_3, " Car Insurance Product Information Document") },
    {
        docType: DocTypeEnum.IPID_ALLIANZ_ESSENTIALS,
        docFullName: "".concat(services_1.resourcesHelper.PRODUCT_TIER_1, " Car Insurance Product Information Document")
    },
    {
        docType: DocTypeEnum.IPID_BRITANNIA_ESSENTIALS,
        docFullName: "".concat(services_1.resourcesHelper.PRODUCT_TIER_1, " Car Insurance Product Information Document")
    },
    {
        docType: DocTypeEnum.IPID_ALLIANZ_SILVER,
        docFullName: "".concat(services_1.resourcesHelper.PRODUCT_TIER_2, " Car Insurance Product Information Document")
    },
    {
        docType: DocTypeEnum.IPID_BRITANNIA,
        docFullName: "".concat(services_1.resourcesHelper.PRODUCT_TIER_2, " Car Insurance Product Information Document")
    },
    { docType: DocTypeEnum.MLE, docFullName: "".concat(services_1.resourcesHelper.PRODUCT, " Motor Legal Expenses Leaflet") }
];
var BrandEnum;
(function (BrandEnum) {
    BrandEnum["Allianz"] = "Allianz";
    BrandEnum["Flow"] = "Flow";
    BrandEnum["Britannia"] = "Britannia";
})(BrandEnum || (BrandEnum = {}));
// Document version when Britannia Rescue BDI document was introduced
exports.omegaBreakDownIntroducedVersion = 7;
function getDocumentVersionByDate(startDate) {
    var annualCarVersionDateArray = services_1.resourcesHelper.THEME === BrandEnum.Britannia ? BritanniaCarVersionDate : AnnualCarVersionDate;
    var documentVersion = annualCarVersionDateArray
        .filter(function (doc) { return doc.versionDate <= startDate; }) // Filter out future dates
        .reduce(function (latest, current) {
        return current.versionDate > latest.versionDate ? current : latest;
    }, { docVersion: DocVersionEnum.V1, versionDate: new Date(0) }).docVersion;
    return documentVersion;
}
function getDocumentVersionNumberOnly(version) {
    // removes leading "v" or "V"
    var num = Number(version === null || version === void 0 ? void 0 : version.replace(/^v/i, ""));
    // in case of an error, use latest document version
    return isNaN(num) ? getDocumentVersionNumberOnly(getLatestDocumentVersion()) : num;
}
function getDocumentBrand(documentVersion) {
    switch (documentVersion) {
        case DocVersionEnum.V1:
        case DocVersionEnum.V2:
        case DocVersionEnum.V3:
            return BrandEnum.Flow;
        default:
            return BrandEnum.Allianz;
    }
}
function getLatestDocumentVersion() {
    return services_1.resourcesHelper.PRODUCT === BrandEnum.Britannia ? BritanniaCarVersionDate[0].docVersion : AnnualCarVersionDate[0].docVersion;
}
var DocumentListModal = /** @class */ (function (_super) {
    __extends(DocumentListModal, _super);
    function DocumentListModal(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.DOC_BASE_PATH = "/resources/documents/";
        _this.documents = [];
        _this.isBritanniaBrand = ["bn", "britannia"].includes(((_a = process.env.REACT_APP_THEME) !== null && _a !== void 0 ? _a : "").toLowerCase());
        _this.getDocumentPath = function (docType, version) {
            var omegaBreakdownRebranding = process.env.REACT_APP_OMEGA_BREAKDOWN_REBRANDING_ENABLED ? JSON.parse(process.env.REACT_APP_OMEGA_BREAKDOWN_REBRANDING_ENABLED) : false;
            if (omegaBreakdownRebranding && DocTypeEnum.BDI === docType && getDocumentVersionNumberOnly(version) >= exports.omegaBreakDownIntroducedVersion) {
                return "".concat(_this.DOC_BASE_PATH, "LV_").concat(_this.documentBrand, "_").concat(_this.documentProduct, "/").concat(version, "/Allianz_Annual_Car_Britannia_Rescue_BDI_").concat(version, ".pdf");
            }
            return "".concat(_this.DOC_BASE_PATH, "LV_").concat(_this.documentBrand, "_").concat(_this.documentProduct, "/").concat(version, "/LV_").concat(_this.documentBrand, "_").concat(_this.documentProduct, "_").concat(docType, "_").concat(version, ".pdf");
        };
        _this.renderPrivacyNoticeLink = function () {
            return ((0, jsx_runtime_1.jsx)("li", { className: "media", children: (0, jsx_runtime_1.jsxs)("a", { className: "document-download-link no-underline", href: PRIVACY_NOTICE_URL, target: "_blank", id: "PLN-privacy", children: [(0, jsx_runtime_1.jsx)("img", { className: "pdf-icon active-icon", alt: "pdf document icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/pdf-icon.png") }), (0, jsx_runtime_1.jsxs)("h5", { className: "document-name d-flex document-link-text", children: ["Privacy Notice | ", services_1.resourcesHelper.THEME, " Insurance"] })] }) }, "PLN-privacy"));
        };
        _this.renderLegalNoticeLink = function () {
            return ((0, jsx_runtime_1.jsx)("li", { className: "media", children: (0, jsx_runtime_1.jsxs)("a", { className: "document-download-link no-underline", href: LEGAL_NOTICE_URL, target: "_blank", id: "PLN-legal", children: [(0, jsx_runtime_1.jsx)("img", { className: "pdf-icon active-icon", alt: "pdf document icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/pdf-icon.png") }), (0, jsx_runtime_1.jsxs)("h5", { className: "document-name d-flex document-link-text", children: ["Legal Notice | ", services_1.resourcesHelper.THEME, " Insurance"] })] }) }, "PLN-legal"));
        };
        _this.renderPLNLinks = function () {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [_this.renderPrivacyNoticeLink(), services_1.resourcesHelper.THEME === 'Britannia' && _this.renderLegalNoticeLink()] }));
        };
        _this.setDocumentProduct();
        _this.setAvailableDocTypesAndVersion();
        _this.setDocumentBrand();
        return _this;
    }
    DocumentListModal.prototype.componentDidMount = function () {
        this.prepareDocuments();
        this.setDocumentSize();
    };
    DocumentListModal.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.coverTier !== prevProps.coverTier
            || this.props.isMLEVisible !== prevProps.isMLEVisible
            || this.props.isBDIVisible !== prevProps.isBDIVisible) {
            this.setAvailableDocTypesAndVersion();
            this.documents = [];
            this.setState({ documents: this.documents });
            this.prepareDocuments();
            this.setDocumentSize();
        }
    };
    DocumentListModal.prototype.prepareDocuments = function () {
        switch (this.documentProduct) {
            case DocProductEnum.ANNUAL_CAR:
                this.handleAnnualCar();
                break;
            case DocProductEnum.CAR:
                this.handleFlowCar();
                break;
            case DocProductEnum.RENTERS:
                this.handleRenters();
                break;
        }
    };
    DocumentListModal.prototype.setDocumentProduct = function () {
        switch (this.props.productName) {
            case services_1.ProductsEnum.WOLF_MOTOR:
                this.documentProduct = DocProductEnum.ANNUAL_CAR;
                break;
            case services_1.ProductsEnum.MOTOR:
            case services_1.ProductsEnum.SUBSCRIPTION:
                this.documentProduct = DocProductEnum.CAR;
                break;
            case services_1.ProductsEnum.RENTERS:
                this.documentProduct = DocProductEnum.RENTERS;
                break;
            default:
                break;
        }
    };
    DocumentListModal.prototype.setAvailableDocTypesAndVersion = function () {
        var coverTier = this.props.coverTier;
        var _a = this.getBrandDocTypes(), essentialsDocType = _a.essentialsDocType, silverDocType = _a.silverDocType, goldDocType = _a.goldDocType;
        switch (this.documentProduct) {
            case DocProductEnum.ANNUAL_CAR:
                if (coverTier === services_1.MOTOR_COVER_TIERS.MOTOR_TIER_1) {
                    this.availableDocTypes = [DocTypeEnum.DOI, essentialsDocType];
                    if (this.props.isMLEVisible) {
                        this.availableDocTypes.push(DocTypeEnum.MLE);
                    }
                }
                else if (coverTier === services_1.MOTOR_COVER_TIERS.MOTOR_TIER_2) {
                    this.availableDocTypes = [DocTypeEnum.DOI, silverDocType];
                    if (this.props.isMLEVisible) {
                        this.availableDocTypes.push(DocTypeEnum.MLE);
                    }
                }
                else {
                    this.availableDocTypes = [DocTypeEnum.DOI, goldDocType, DocTypeEnum.MLE];
                }
                if (this.props.isBDIVisible) {
                    this.availableDocTypes.push(DocTypeEnum.BDI);
                }
                this.setVersionByDate();
                break;
            case DocProductEnum.CAR:
                this.availableDocTypes = [DocTypeEnum.DOI, DocTypeEnum.IPID, DocTypeEnum.MLE];
                this.setVersionByDate();
                break;
            case DocProductEnum.RENTERS:
                this.availableDocTypes = [DocTypeEnum.DOI, DocTypeEnum.IPID];
                this.setVersionByDate();
                break;
        }
    };
    DocumentListModal.prototype.getBrandDocTypes = function () {
        return {
            essentialsDocType: this.isBritanniaBrand ? DocTypeEnum.IPID_BRITANNIA_ESSENTIALS : DocTypeEnum.IPID_ALLIANZ_ESSENTIALS,
            silverDocType: this.isBritanniaBrand ? DocTypeEnum.IPID_BRITANNIA : DocTypeEnum.IPID_ALLIANZ_SILVER,
            goldDocType: this.isBritanniaBrand ? DocTypeEnum.IPID_BRITANNIA_PREMIER : DocTypeEnum.IPID
        };
    };
    DocumentListModal.prototype.setVersionByDate = function () {
        this.documentVersion = getDocumentVersionByDate(this.props.policyDate);
    };
    DocumentListModal.prototype.setDocumentBrand = function () {
        if (services_1.resourcesHelper.THEME === BrandEnum.Britannia) {
            this.documentBrand = BrandEnum.Britannia;
            return;
        }
        this.documentBrand = getDocumentBrand(this.documentVersion);
    };
    DocumentListModal.prototype.handleAnnualCar = function () {
        var _this = this;
        switch (this.documentBrand) {
            case BrandEnum.Allianz:
                this.availableDocTypes.forEach(function (docType) {
                    if (docType === DocTypeEnum.BDI && _this.props.addedBDIDate) {
                        _this.createDocument(docType, getDocumentVersionByDate(_this.props.addedBDIDate));
                    }
                    else if (docType === DocTypeEnum.MLE && _this.props.addedMLEDate) {
                        _this.createDocument(docType, getDocumentVersionByDate(_this.props.addedMLEDate));
                    }
                    else {
                        _this.createDocument(docType);
                    }
                });
                break;
            case BrandEnum.Britannia:
                this.availableDocTypes.forEach(function (docType) {
                    _this.createDocument(docType);
                });
                break;
            case BrandEnum.Flow:
                switch (this.documentVersion) {
                    case DocVersionEnum.V1:
                        this.availableDocTypes.forEach(function (docType) {
                            _this.createDocument(docType);
                        });
                        break;
                    case DocVersionEnum.V2:
                    case DocVersionEnum.V3:
                        if (this.props.isBDIVisible) {
                            this.createDocument(DocTypeEnum.BDI, DocVersionEnum.V1);
                        }
                        this.createDocument(DocTypeEnum.DOI);
                        this.createDocument(DocTypeEnum.IPID);
                        this.createDocument(DocTypeEnum.MLE, DocVersionEnum.V1);
                        break;
                }
                break;
        }
    };
    DocumentListModal.prototype.handleFlowCar = function () {
        var _this = this;
        switch (this.documentVersion) {
            case DocVersionEnum.V1:
            case DocVersionEnum.V3:
                this.availableDocTypes.forEach(function (docType) {
                    _this.createDocument(docType);
                });
                break;
            case DocVersionEnum.V2:
                this.createDocument(DocTypeEnum.DOI);
                this.createDocument(DocTypeEnum.IPID, DocVersionEnum.V1);
                this.createDocument(DocTypeEnum.MLE, DocVersionEnum.V1);
        }
    };
    DocumentListModal.prototype.handleRenters = function () {
        var _this = this;
        switch (this.documentVersion) {
            case DocVersionEnum.V1:
                this.availableDocTypes.forEach(function (docType) {
                    _this.createDocument(docType);
                });
                break;
            case DocVersionEnum.V2:
                this.createDocument(DocTypeEnum.DOI, DocVersionEnum.V2);
                this.createDocument(DocTypeEnum.IPID, DocVersionEnum.V1);
                break;
        }
    };
    DocumentListModal.prototype.createDocument = function (docType, version) {
        var _this = this;
        if (version === void 0) { version = this.documentVersion; }
        this.getDocumentSize(this.getDocumentPath(docType, version)).subscribe(function (size) {
            if (size) {
                var document_1 = {
                    key: (0, uuid_1.v4)(),
                    href: _this.getDocumentPath(docType, version),
                    documentId: "".concat(docType, "_DOC"),
                    documentName: _this.getDocumentFullName(docType, version),
                    documentFileSize: size,
                };
                _this.setState(function (prev) { return ({ documents: __spreadArray(__spreadArray([], prev.documents, true), [document_1], false) }); });
            }
        });
    };
    DocumentListModal.prototype.getDocumentFullName = function (docType, version) {
        var versionList = this.isBritanniaBrand ? [ /* offline versions for britannia */]
            : [DocVersionEnum.V1, DocVersionEnum.V2, DocVersionEnum.V3, DocVersionEnum.V4, DocVersionEnum.V5, DocVersionEnum.V6, DocVersionEnum.V7, DocVersionEnum.V8];
        if (versionList.some(function (v) { return v === version; })) {
            return "".concat(DocNameMap.find(function (d) { return d.docType === docType; }).docFullName);
        }
        return "".concat(DocNameMapOnline.find(function (d) { return d.docType === docType; }).docFullName);
    };
    DocumentListModal.prototype.getDocumentSize = function (path) {
        var _this = this;
        return new rxjs_1.Observable(function (observer) {
            _this.baseRequestService.getDocumentSize(path).subscribe(function (response) {
                var size = (0, commonFunctions_1.formatFileSize)(response.xhr.getResponseHeader('content-length'));
                observer.next(size);
                observer.complete();
            });
        });
    };
    DocumentListModal.prototype.setDocumentSize = function () {
        var _this = this;
        this.documents.forEach(function (doc) {
            _this.baseRequestService.getDocumentSize(doc.href).subscribe(function (response) {
                doc.documentFileSize = (0, commonFunctions_1.formatFileSize)(response.xhr.getResponseHeader('content-length'));
            });
        });
        this.setState({
            documents: this.documents
        });
    };
    DocumentListModal.prototype.render = function () {
        if (this.state) {
            var documentRender = this.state.documents.map(function (document) { return ((0, jsx_runtime_1.jsx)("li", { className: "media", children: (0, jsx_runtime_1.jsxs)("a", { className: "document-download-link no-underline", href: document.href, download: document.documentName.toLowerCase().endsWith('.pdf') ? document.documentName : "".concat(document.documentName, ".pdf"), id: document.documentId, children: [(0, jsx_runtime_1.jsx)("img", { className: "pdf-icon active-icon", alt: "pdf document icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/pdf-icon.png") }), (0, jsx_runtime_1.jsxs)("h5", { className: "document-name d-flex document-link-text", children: [document.documentName, " (PDF, ", document.documentFileSize, ")"] })] }) }, document.documentId)); });
            documentRender.push(this.renderPLNLinks());
            if (this.props.isAccordion) {
                return documentRender;
            }
            else {
                return (0, jsx_runtime_1.jsx)("ul", { className: "list-unstyled", children: documentRender });
            }
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.BaseRequestService),
        __metadata("design:type", Object)
    ], DocumentListModal.prototype, "baseRequestService", void 0);
    return DocumentListModal;
}(React.Component));
exports.DocumentListModal = DocumentListModal;
//# sourceMappingURL=DocumentListModal.js.map